import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { frame: String }

  connect() {
    const frame = document.querySelector(`turbo-frame#${this.frameValue}`)
    if (frame) {
      const src = frame.getAttribute("src")
      if (src) {
        frame.removeAttribute("src")
        frame.setAttribute("src", src)
      }
    }
  }
}
